<template>
  <!-- Main wrapper  -->
  <div id="main-wrapper">
    <div class="unix-login">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-4 col-md-8 col-sm-12">
            <div class="login-content card">
              <div class="login-form">
                <h4>Forgot Password</h4>
                <div v-if="!resetStatus">
                  <form v-if="!token" @submit="resetPassword">
                    <div class="form-group">
                      <input type="email" v-model="email" class="form-control" placeholder="Email *">
                    </div>
                    <div>
                      *We will email you further instructions
                    </div>
                    <button :disabled="!email || !validateEmail(email)" type="submit"
                            class="btn btn-primary btn-flat m-b-30 m-t-30">Email reset
                      instructions
                    </button>
                  </form>
                  <form v-else @submit="changePassword">
                    <div class="form-group">
                      <input type="password" v-model="password" class="form-control" placeholder="Password *">
                    </div>
                    <div class="form-group">
                      <input type="password" v-model="password2" class="form-control" placeholder="Password repeat *">
                    </div>
                    <div>
                      *This is temporary unavailable
                    </div>
                    <button :disabled="!password || password!==password2" type="submit"
                            class="btn btn-primary btn-flat m-b-30 m-t-30">Change password
                    </button>
                  </form>
                </div>
                <div v-else>
                  <div v-if="resetStatus===1">
                    <p>Your request to reset password was submitted! Please check your email, we have sent an approval
                      letter.</p>
                  </div>
                  <div v-else-if="resetStatus===2">
                    <p>There has been a temporary issue. Please try again later.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End Wrapper -->
</template>

<script>
/* eslint-disable */
  export default {
    name: 'ForgotPassword',
    data() {
      return {
        resetStatus: 0,
        email: null,
        password: null,
        password2: null,
        token: null,
        gToken: null
      };
    },
    methods: {
      resetPassword(e) {
        e.preventDefault();
        let data = { email: this.email.trim(), gToken: this.gToken };
        this.axios.post(this.$root.$data.api.user + 'reset-password', data)
          .then(response => {
            this.resetStatus = 1;
          }, response => {
            this.resetStatus = 2;
          });
      },
      changePassword(e) {
        e.preventDefault();

        if (!this.password2 || !this.password) return;
        let data = {
          password: this.password.trim(),
          passwordConfirm: this.password2.trim(),
          token: this.token,
          gToken: this.gToken
        };
        this.axios.post(this.$root.$data.api.user + 'set-password', data)
          .then(response => {
            location.href = '/#/Login';
          }, response => {
            this.resetStatus = 2;
          });
      },
      validateEmail(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email)
          .toLowerCase());
      }
    },
    mounted() {
      if (this.$route.query.token) {
        this.token = this.$route.query.token;
      }
      let self = this;
      grecaptcha.ready(function () {
        grecaptcha.execute('6LcM7X0UAAAAAIDGLwBItz518xeb4cRC5dvuWGTW', { action: 'reset' })
          .then(function (token) {
            self.gToken = token;
          });
      });
    }
  };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword/ForgotPassword.vue